import * as React from "react";
import { cn } from "lib/utils";

interface LogoProps {
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
  className?: string;
}

export function Logo({
  src = "/logos/svg/brev-logo.svg",
  alt = "NVIDIA Brev logo",
  width = "32px",
  height = "32px",
  className,
}: LogoProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn(className)}
      style={{ width, height }}
    />
  );
}
